import React from 'react'

function ListSingle(props) {
  return (
    <div className='list-wrap'><span>{props.name}</span><span>{props.place}</span><span>{props.sector}</span></div>
  )
}

export default ListSingle